import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "@/pages/Home";
import ListingDetail from "@/pages/ListingDetail";
import WhyManzano from "@/pages/WhyManzano";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import ListingForm from "@/pages/admin/ListingForm";
import TestimonialForm from "@/pages/admin/TestimonialForm";
import SocialVideoForm from "@/pages/admin/SocialVideoForm";
import PostForm from "@/pages/admin/PostForm";
import GamePlanForm from "@/pages/admin/GamePlanForm";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import GamePlan from "@/pages/GamePlan";
import { Toaster } from "@/components/ui/sonner";
import { getToken } from "@/lib/api";

const RequireAdmin = ({ children }) => {
  if (!getToken()) return <Navigate to="/admin/login" replace />;
  return children;
};

// Reset scroll position on every route change (and disable browser scroll restore).
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/listings/:slug" element={<ListingDetail />} />
          <Route path="/why-manzano" element={<WhyManzano />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/gameplan" element={<GamePlan />} />
          <Route path="/game-plan" element={<GamePlan />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/listings/new"
            element={
              <RequireAdmin>
                <ListingForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/listings/:id/edit"
            element={
              <RequireAdmin>
                <ListingForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/testimonials/new"
            element={
              <RequireAdmin>
                <TestimonialForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/testimonials/:id/edit"
            element={
              <RequireAdmin>
                <TestimonialForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/social-videos/new"
            element={
              <RequireAdmin>
                <SocialVideoForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/social-videos/:id/edit"
            element={
              <RequireAdmin>
                <SocialVideoForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/posts/new"
            element={
              <RequireAdmin>
                <PostForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/posts/:id/edit"
            element={
              <RequireAdmin>
                <PostForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/game-plan/new"
            element={
              <RequireAdmin>
                <GamePlanForm />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/game-plan/:id/edit"
            element={
              <RequireAdmin>
                <GamePlanForm />
              </RequireAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
